import Axios from 'axios';
import React, {useContext, useEffect, useState} from 'react';
import {Store} from '../../Store';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import {Helmet} from 'react-helmet-async';
import {toast} from 'react-toastify';
import {getError} from '../../utils';
import {Link, useNavigate} from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import Spinner from 'react-bootstrap/Spinner';
import {api} from "../../Api";

export default function ConfigScreen() {
  const { state } = useContext(Store);
  const { userInfo } = state;
  const myId = userInfo._id;
  const [loading, setLoading] = useState(0);
  const [siteStatus, setSiteStatus] = useState(0);
  const [referenceCommission, setreferenceCommission] = useState(0);
  const [matchingCommission, setmatchingCommission] = useState(0);
  const [pointValue, setpointValue] = useState(0);
  const [currency, setcurrency] = useState(0);
  const [withdraw, setwithdraw] = useState(0);
  const [offDay, setoffDay] = useState(0);
  const [dayCloseExtensionHours, setDayCloseExtensionHours] = useState(0);
  const EXT_CATEGORIES = [
    { key: 'accountCreation', label: 'New accounts (ID creation + bonuses)' },
    { key: 'topup', label: 'Topup requests' },
    { key: 'withdraw', label: 'Withdraw requests' },
    { key: 'transfer', label: 'Point transfers' },
    { key: 'convert', label: 'Point conversions' },
    { key: 'order', label: 'Orders' },
  ];
  const [dayCloseExtensionIncludes, setDayCloseExtensionIncludes] = useState({
    accountCreation: true,
    topup: true,
    withdraw: true,
    transfer: true,
    convert: true,
    order: true,
  });

  const fetchData = async () => {
    try {
      setLoading(1);
      const { data } = await Axios.get(api + `/api/users/getconfig`, {
        headers: { authorization: `Bearer ${userInfo.token}` },
      });
      setSiteStatus(data.siteStatus);
      setreferenceCommission(data.referenceCommission);
      setmatchingCommission(data.matchingCommission);
      setpointValue(data.pointValue);
      setcurrency(data.currency);
      setwithdraw(data.withdraw);
      setoffDay(data.offDay);
      setDayCloseExtensionHours(data.dayCloseExtensionHours ?? 0);
      // Missing keys default to INCLUDED — same rule as the backend.
      setDayCloseExtensionIncludes((prev) =>
        Object.keys(prev).reduce(
          (acc, key) => ({
            ...acc,
            [key]: data.dayCloseExtensionIncludes?.[key] ?? true,
          }),
          {}
        )
      );
      setLoading(0);
    } catch (error) {
      toast.error(getError(error));
    }
  };

  useEffect(() => {
    fetchData();
  }, [userInfo, myId]);

  const navigate = useNavigate();

  async function save() {
    try {
      setLoading(1);
      const { save } = await Axios.put(
        api + '/api/users/saveconfig',
        {
          siteStatus: siteStatus,
          referenceCommission: referenceCommission,
          matchingCommission: matchingCommission,
          pointValue: pointValue,
          currency: currency,
          withdraw: withdraw,
          offDay: offDay,
          dayCloseExtensionHours: dayCloseExtensionHours,
          dayCloseExtensionIncludes: dayCloseExtensionIncludes,
          // minimumTransfer, withdrawCharge, and convertCharge deliberately
          // absent — they moved to Money Controls, and /saveconfig now only
          // writes what it is sent, so leaving them out preserves whatever is
          // set there.
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        }
      );
      toast.success('Data Saved');
      fetchData();
    } catch (error) {
      toast.error(getError(error));
    }
  }
  return (
    <div>
      <Helmet>
        <title>Settings</title>
      </Helmet>
      <Container>
        <div className="card">
          <div className="card-body">
            <Accordion defaultActiveKey="0" flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>General Settings</Accordion.Header>
                <Accordion.Body>
                  <table className="table table-responsive">
                    <thead>
                      <tr>
                        <td>Under Maintenance</td>
                        <td>:</td>
                        <td>
                          <select
                            className="form-control"
                            onChange={(e) => setSiteStatus(e.target.value)}
                            value={siteStatus}
                          >
                            <option value="1">Enabled </option>
                            <option value="0">Disabled</option>
                          </select>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Reference Commission</td>
                        <td>:</td>
                        <td>
                          <input
                            className="form-control"
                            onChange={(e) =>
                              setreferenceCommission(e.target.value)
                            }
                            value={referenceCommission}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Matching Commission</td>
                        <td>:</td>
                        <td>
                          <input
                            className="form-control"
                            onChange={(e) =>
                              setmatchingCommission(e.target.value)
                            }
                            value={matchingCommission}
                          />
                        </td>
                      </tr>
                      <tr className="d-none">
                        <td>Point value</td>
                        <td>:</td>
                        <td>
                          <input
                            className="form-control"
                            onChange={(e) => setpointValue(e.target.value)}
                            value={pointValue}
                          />
                        </td>
                      </tr>
                      <tr className="d-none">
                        <td>Currency</td>
                        <td>:</td>
                        <td>
                          <input
                            className="form-control"
                            onChange={(e) => setcurrency(e.target.value)}
                            value={currency}
                          />
                        </td>
                      </tr>
                      <tr className="d-none">
                        <td>Withdraw</td>
                        <td>:</td>
                        <td>
                          <input
                            className="form-control"
                            onChange={(e) => setwithdraw(e.target.value)}
                            value={withdraw}
                          />
                        </td>
                      </tr>
                      <tr className="d-none">
                        <td>offDay</td>
                        <td>:</td>
                        <td>
                          <input
                            className="form-control"
                            onChange={(e) => setoffDay(e.target.value)}
                            value={offDay}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Day Close Extension (hours)</td>
                        <td>:</td>
                        <td>
                          <input
                            className="form-control"
                            type="number"
                            min={0}
                            max={12}
                            step={1}
                            onChange={(e) =>
                              setDayCloseExtensionHours(e.target.value)
                            }
                            value={dayCloseExtensionHours}
                          />
                          <div className="form-text">
                            0 = off. When set (e.g. 2), the ticked record types
                            created in the first N hours after midnight are
                            stamped to 11:59 PM of the previous day, so every
                            report counts them in the previous day and month.
                            Every use is written to the audit log.
                          </div>
                          <div className="mt-2">
                            {EXT_CATEGORIES.map((c) => (
                              <div className="form-check" key={c.key}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`ext-${c.key}`}
                                  checked={!!dayCloseExtensionIncludes[c.key]}
                                  onChange={(e) =>
                                    setDayCloseExtensionIncludes((prev) => ({
                                      ...prev,
                                      [c.key]: e.target.checked,
                                    }))
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`ext-${c.key}`}
                                >
                                  {c.label}
                                </label>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Withdraw, Transfer &amp; Convert</td>
                        <td>:</td>
                        <td>
                          <Link
                            to="/admin/money-controls"
                            className="btn btn-outline-secondary btn-sm w-100"
                          >
                            Open Money Controls
                          </Link>
                          <div className="form-text">
                            On/off switches, minimum and maximum amounts, and
                            the charge for withdrawals, point transfers, and
                            point conversion.
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan={3}>
                          <Button
                            variant="outline-primary w-100"
                            onClick={save}
                          >
                            {loading ? (
                              <Spinner
                                animation="border"
                                size="sm"
                                variant="primary"
                              />
                            ) : (
                              'Save'
                            )}
                          </Button>{' '}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </Container>
    </div>
  );
}
